const ZH = {
  ZOOM_IN: '放大',
  ZOOM_OUT: '缩小',
  TOPIC_SHAPE: '主题形状',
  TOPIC_ADD: '添加主题',
  TOPIC_DELETE: '删除主题',
  TOPIC_ICON: '添加图标',
  TOPIC_LINK: '添加链接',
  TOPIC_RELATIONSHIP: '关系',
  TOPIC_COLOR: '主题颜色',
  TOPIC_BORDER_COLOR: '主题边框颜色',
  TOPIC_NOTE: '添加注释',
  FONT_FAMILY: '字体类型',
  FONT_SIZE: '文本大小',
  FONT_BOLD: '粗体文本',
  FONT_ITALIC: '斜体文本',
  UNDO: '撤销',
  REDO: '重做',
  INSERT: '插入',
  SAVE: '保存',
  NOTE: '注释',
  ADD_TOPIC: '添加主题',
  LOADING: '加载......',
  EXPORT: '导出',
  PRINT: '打印',
  PUBLISH: '发布',
  COLLABORATE: '分享',
  HISTORY: '历史',
  DISCARD_CHANGES: '放弃更改',
  FONT_COLOR: '文本颜色',
  SAVING: '保存......',
  SAVE_COMPLETE: '保存完成',
  ZOOM_IN_ERROR: '放大比例过高。',
  ZOOM_ERROR: '无法再缩放了。',
  ONLY_ONE_TOPIC_MUST_BE_SELECTED: '无法创建主题。只能选择一个主题。',
  ONE_TOPIC_MUST_BE_SELECTED: '无法创建主题。必须选择一个主题。',
  ONLY_ONE_TOPIC_MUST_BE_SELECTED_COLLAPSE: '无法折叠子节点，必须只选择一个主题。',
  SAVE_COULD_NOT_BE_COMPLETED: '无法完成保存，请稍后再试。',
  UNEXPECTED_ERROR_LOADING: '我们很抱歉，发生了意外错误。\n再次尝试重新加载编辑器。如果问题仍然存在，请联系我们support@wisemapping.com。',
  MAIN_TOPIC: '重点主题',
  SUB_TOPIC: '子主题',
  ISOLATED_TOPIC: '独立主题',
  CENTRAL_TOPIC: '中心主题',
  SHORTCUTS: '键盘快捷键',
  ENTITIES_COULD_NOT_BE_DELETED: '无法删除主题或关系。至少选择一个脑图实体。',
  AT_LEAST_ONE_TOPIC_MUST_BE_SELECTED: '至少要选择一个主题',
  CLIPBOARD_IS_EMPTY: '没有东西可以复制。剪贴板是空的。',
  CENTRAL_TOPIC_CAN_NOT_BE_DELETED: '无法删除中心主题。',
  RELATIONSHIP_COULD_NOT_BE_CREATED: '无法创建关系。必须先选择要建立关系的主题。',
  SELECTION_COPIED_TO_CLIPBOARD: '主题已复制到剪贴板',
  WRITE_YOUR_TEXT_HERE: '在这里写你的注释......',
  REMOVE: '删除',
  ACCEPT: '接受',
  CANCEL: '取消',
  LINK: '链接',
  OPEN_LINK: '打开URL',
  SESSION_EXPIRED: '您的会话已过期，请重新登录。',
  URL_ERROR: 'URL无效',
  ACTION: '操作',
  CREATE_SIBLING_TOPIC: '创建并行主题',
  CREATE_CHILD_TOPIC: '创建子主题',
  DELETE_TOPIC: '删除主题',
  EDIT_TOPIC_TEXT: '编辑主题文本',
  JUST_START_TYPING: '开始打字',
  CANCEL_TEXT_CHANGES: '取消文本更改',
  TOPIC_NAVIGATION: '主题导航',
  ARROW_KEYS: '方向按键',
  SELECT_MULTIPLE_NODES: '选择多个节点',
  UNDO_EDITION: '撤销编辑',
  REDO_EDITION: '重做修改',
  SELECT_ALL_TOPIC: '选择所有主题',
  CHANGE_TEXT_BOLD: '更改粗体文本',
  SAVE_CHANGES: '保存更改',
  CHANGE_TEXT_ITALIC: '更改斜体文本',
  DESELECT_ALL_TOPIC: '取消选择所有主题',
  COLLAPSE_CHILDREN: '折叠子节点',
  KEYBOARD_SHORTCUTS_MSG: '键盘快捷键可以让你永远不用把手从键盘上拿开来使用鼠标，从而帮助你节省时间。',
  COPY_AND_PASTE_TOPICS: '复制和粘贴主题',
  MULTIPLE_LINES: '添加多行文本',
  BACK_TO_MAP_LIST: '回到脑图列表',
  KEYBOARD_SHOTCUTS: '键盘快捷键',
  PASTE_URL_HERE: '在此处粘贴所需的 URL 地址:',

};

export default ZH;
